/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Add_CertificateInputs */

const en_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Certificate`)
};

const de_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Zertifikat hinzufuegen`)
};

const fr_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter un certificat`)
};

const es_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Anadir certificado`)
};

const it_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi certificato`)
};

const nl_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Certificaat toevoegen`)
};

const pl_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Dodaj certyfikat`)
};

const fi_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lisää todistus`)
};

const da_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Tilföj certifikat`)
};

const sv_resume_editor_add_certificate = /** @type {(inputs: Resume_Editor_Add_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lagg till certifikat`)
};

/**
* | output |
* | --- |
* | "+ Add Certificate" |
*
* @param {Resume_Editor_Add_CertificateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_add_certificate = /** @type {((inputs?: Resume_Editor_Add_CertificateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Add_CertificateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_add_certificate(inputs)
	if (locale === "fr") return fr_resume_editor_add_certificate(inputs)
	if (locale === "es") return es_resume_editor_add_certificate(inputs)
	if (locale === "it") return it_resume_editor_add_certificate(inputs)
	if (locale === "nl") return nl_resume_editor_add_certificate(inputs)
	if (locale === "pl") return pl_resume_editor_add_certificate(inputs)
	if (locale === "fi") return fi_resume_editor_add_certificate(inputs)
	if (locale === "da") return da_resume_editor_add_certificate(inputs)
	if (locale === "sv") return sv_resume_editor_add_certificate(inputs)
	return en_resume_editor_add_certificate(inputs)
});